module.exports = __webpack_public_path__ + "img/1510657094.dd28045d.jpg";